import { component } from 'picoapp'

export default component((node, ctx) => {
    
    const video_id = node.dataset.videoid;
    const video_type = node.dataset.videotype;
    const playbtn = node.querySelector('.js-play-video');
    const player = document.createElement('iframe');
    const player_container = document.querySelector('.video__container');

    player.width = '560';
    player.height = '315';
    player.frameBorder = '0';
    player.allowFullscreen = 'allowfullscreen';

    if (video_type == 'youtube') {
        player.src = 'https://www.youtube.com/embed/' + video_id + '?autoplay=1&rel=0';
        player.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    } else if (video_type == 'vimeo') {
        player.src = 'https://player.vimeo.com/video/' + video_id + '?autoplay=1';
        player.allow = 'autoplay; fullscreen';
    }

    //<iframe width="560" height="315" src="https://www.youtube.com/embed/{{ section.settings.video_url.id }}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

    //<iframe src="https://player.vimeo.com/video/{{ section.settings.video_url.id }}" width="640" height="379" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

    playbtn.addEventListener('click', e => {
        e.preventDefault();
        playbtn.classList.add('playing');
        player_container.appendChild(player);
    });

})
